// Generated by CoffeeScript 2.7.0
import Admin__MessagesController from './messages.js';

import Admin__Messages__SearchesController from './searches.js';

import Admin__Messages__SettingsController from './settings.js';

import Admin__FormsController from './forms.js';

import Admin__PostsController from './posts.js';

import Admin__TemplatePostsController from './template_posts.js';

import Admin__WebhooksController from './webhook.js';

import Admin__ResponsesController from './responses.js';

import Admin__PushesController from './pushes.js';

Skylark.App.Controllers.register({Admin__MessagesController, Admin__Messages__SearchesController, Admin__Messages__SettingsController, Admin__FormsController, Admin__PostsController, Admin__TemplatePostsController, Admin__WebhooksController, Admin__ResponsesController, Admin__PushesController});
